// src/features/business-functions/components/workspace-detail/WorkspaceHeader.jsx
import React, { useState } from 'react';
import { Box, Typography, Button, IconButton, Menu, MenuItem, Skeleton } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import GroupsIcon from '@mui/icons-material/Groups';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { CAMPAIGN_COPY } from '../../constants/campaignCopy';
import LeadDashboardHelp from '../../../../components/Shared/HelpFIles/LeadDashboardHelp.tsx';

const ICON_MAP = {
  Groups: GroupsIcon,
  FilterAlt: FilterAltIcon,
  PersonOutline: PersonOutlineIcon,
  Assessment: AssessmentIcon,
  TaskAlt: TaskAltIcon,
  Description: DescriptionIcon,
  FolderOpen: FolderOpenIcon,
};

/**
 * Workspace Header component — displays Workspace Icon, Name, Active Badge,
 * Description, Star favorite button, Share button, and "+ New" CTA dropdown.
 */
export default function WorkspaceHeader({
  workspace,
  styles,
  isLoading,
  onCreateClick,
  canCreateTable = false,
}) {
  const [isStarred, setIsStarred] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  if (isLoading || !workspace) {
    return (
      <Box sx={styles.workspaceDetailHeaderRoot}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flex: 1, minWidth: 0 }}>
          <Skeleton variant="rectangular" width={48} height={48} sx={{ borderRadius: 0, flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              <Skeleton variant="text" width={220} height={36} sx={{ transform: 'none' }} />
              <Skeleton variant="rounded" width={56} height={22} sx={{ borderRadius: 0 }} />
            </Box>
            <Skeleton variant="text" width="min(420px, 100%)" height={20} sx={{ mt: 0.5 }} />
          </Box>
        </Box>

        <Box sx={styles.workspaceDetailHeaderActions}>
          <Skeleton variant="rounded" width={88} height={36} sx={{ borderRadius: 0 }} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="rounded" width={88} height={36} sx={{ borderRadius: 0 }} />
        </Box>
      </Box>
    );
  }

  const IconComp = ICON_MAP[workspace.iconName] || FolderOpenIcon;

  return (
    <Box sx={styles.workspaceDetailHeaderRoot}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
        {/* Workspace Icon */}
        <Box  sx={{
          ...styles.workspaceDetailIconWrap,
          bgcolor: '#ebf5ef',
        }}>
          <IconComp fontSize="medium" />
        </Box>

        {/* Title & Description */}
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Typography component="h1" sx={styles.workspaceDetailTitle}>
              {workspace.name}
            </Typography>

            <Box component="span" sx={styles.statusBadgeActive}>
              {workspace.status || 'Active'}
            </Box>

            {/* <IconButton
              size="small"
              onClick={() => setIsStarred(!isStarred)}
              aria-label={CAMPAIGN_COPY.detail.starAriaLabel}
              sx={{ color: isStarred ? 'warning.main' : 'action.active' }}
            >
              {isStarred ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
            </IconButton> */}
          </Box>

          <Typography sx={styles.workspaceDetailDescription}>
            {workspace.description || 'Manage leads, prospects, and track sales pipeline efficiently.'}
          </Typography>
        </Box>
      </Box>

      {/* Action Buttons */}
      <Box sx={styles.workspaceDetailHeaderActions}>
        {/* <Button
          variant="outlined"
          startIcon={<ShareOutlinedIcon />}
          sx={styles.workspaceShareBtn}
        >
          Share
        </Button>

        <IconButton size="small" aria-label={CAMPAIGN_COPY.detail.optionsAriaLabel}>
          <MoreVertIcon fontSize="small" />
        </IconButton> */}
        <LeadDashboardHelp />

        {canCreateTable ? (
          <>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              // onClick={(e) => setAnchorEl(e.currentTarget)}
              onClick={() => { setAnchorEl(null); onCreateClick?.('table'); }}
              sx={styles.workspacesNewBtn}
              disableElevation
            >
              New Form
            </Button>

            {/* <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{ sx: { borderRadius: 0 } }}
            >
              <MenuItem onClick={() => { setAnchorEl(null); onCreateClick?.('table'); }}>
                + New Form
              </MenuItem> */}
              {/* <MenuItem title="Report creation will be available in a later release">
                + New Report
              </MenuItem>
              <MenuItem title="Automation creation will be available in a later release">
                + New Automation
              </MenuItem> */}
            {/* </Menu> */}
          </>
        ) : null}
      </Box>
    </Box>
  );
}
